import React from 'react';
import { string, object } from 'prop-types';

const Page = ({ workflowState, component, state }) => {
  if (state !== workflowState) return null;
  const Component = component;
  return <Component />;
};

Page.propTypes = {
  workflowState: string.isRequired,
  component: object.isRequired,
  state: string.isRequired,
};

export default Page;
